import { isArray } from 'lodash-es'
import { Tooltip } from 'antd'

export const config = {
  rowSelection: false,
  pagination: false,
  columns: [
    {
      title: 'SKU_ID',
      key: 'id',
      dataIndex: 'id',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: 'SKU名称',
      key: 'skuName',
      dataIndex: 'skuName',
      width: 220,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '规格',
      key: 'argName',
      dataIndex: 'argName',
      width: 120,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '单位',
      key: ['unitInfo', 'unitName'],
      dataIndex: ['unitInfo', 'unitName'],
      width: 120,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: 'SKU适用门店',
      dataIndex: ['productSku'],
      render: (_, record: Record<string, any>)=>{
        const shopList = isArray(record?.shops)?record?.shops:[];
        const txt = shopList?.map(item => item.companyName).join(',');
        return <Tooltip title={txt||""} placement="topLeft">
          <div style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',width:190}}>{txt||""}</div>
        </Tooltip>
      },
      width: 200,
    },
    {
      title: 'SKU状态',
      dataIndex: ['enabled'],
      width: 100,
      render: 'enableRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'id',
      label: 'SKU_ID',
    },
    {
      name: 'skuNameKeyword',
      label: 'SKU名称',
    },
  ],
}
